

















































import DsModal from '@/shared/modal/ds-modal.vue';
import { PropType } from 'vue';
import { Account, Channel } from '@/shared/model/scrap-agent.model';

export default {
  components: { DsModal },
  props: {
    open: Boolean,
    // channelConnect: {
    //   type: Object as PropType<Channel>,
    //   required: true,
    // },
  },
  data() {
    return {
      showModal: this.open,
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit('modal:close');
    },
    handleShowAddAccount() {
      this.$emit('modal:AddAccount');
    },
    handleSubmitAccount(value: Account) {
      this.$emit('modal:SubmitAccount', value);
    },
  },
  watch: {
    open(value) {
      this.showModal = value;
    },
    showModal(value) {
      this.$emit('update:open', value);
    },
  },
};
